import Icon from '../components/Icon.vue'

Icon.register({"copyright":{"width":512,"height":512,"paths":[{"d":"M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM373.1 354.8C371.5 356.6 333.4 400.5 263.3 400.5 178.6 400.5 118.8 337.2 118.8 254.9 118.8 173.6 180.8 111.5 262.6 111.5 329.5 111.5 364.5 148.8 366 150.4A12-12 0 0 0 367.2 165L344.8 199.7C340.8 206 332.1 207 326.6 202 326.4 201.8 300.1 178.1 264.7 178.1 218.6 178.1 190.8 211.7 190.8 254.2 190.8 293.8 216.3 333.9 265.1 333.9 303.8 333.9 330.4 305.5 330.6 305.3 335.8 299.7 344.7 300.2 349.1 306.3L373.7 339.9A12-12 0 0 0 373.1 354.8z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/copyright.js
// module id = hxGs
// module chunks = 0